const selectDebugInfoByItemId = (debugData, itemId) =>
  debugData.itemDebugData[itemId] || {};

export default {
  selectDebugInfoByItemId,
};
